// Load Bootstrap
require('bootstrap-sass/assets/javascripts/bootstrap.min');

// Load Slick
require('slick-carousel/slick/slick.min');

// Load jquery-menu-aim
require('jquery-menu-aim/jquery.menu-aim');

// Load intl-tel-input
require('intl-tel-input/build/js/intlTelInput.min');

require('./objects/ui-o-form');
require('./components/ui-c-slider/index');
require('./components/ui-c-menu');



// WEBPACK FOOTER //
// ./src/js/main.js